import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { Flex } from 'components/Flex'
import { Marker } from 'react-map-gl'
import styles from './Pin.module.scss'

type PinProps = {
  longitude: number
  latitude: number
}

export const Pin: FC<PinProps> = ({ latitude, longitude }) => {
  const offset = parseInt(styles.pinSize) / 2

  return (
    <Marker longitude={longitude} latitude={latitude} offsetLeft={-offset} offsetTop={-offset}>
      <Flex align="center" justify="center" className={styles.pin}>
        <Icon name="map-pin-line" data-testid={`marker ${latitude} ${longitude}`} />
      </Flex>
    </Marker>
  )
}

Pin.displayName = 'Pin'
